module.exports = __webpack_public_path__ + "static/media/background1.4402aab9.png";